import React, {Fragment, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import * as api from "../../apis/productQr";
import useAntTable from "../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import withAuth from "../../utils/withAuth";
import {Button, Divider, Popconfirm, Space, Typography} from "antd";
import {useRequest} from "ahooks";
import UploadModal from "../../components/UploadModal";

const ImportButton = withAuth('import', Button)
const EditFragment = withAuth('edit', Fragment)
const DeletePopconfirm = withAuth('delete', Popconfirm)
const DeleteButton = withAuth('delete', Button)

function ProductQr() {
    const {
        tableProps,
        refresh,
        editingKey,
        edit,
        saveEdit,
        cancelEdit,
        selectedRowKeys
    } = useAntTable(api.getProductQrs, {
        onSave: (id, record) => onModify({id, ...record}),
        selectable: true
    })
    const [importModalVisible, setImportModalVisible] = useState(false)

    const {run: onImport, loading: onImporting} = useRequest(api.importProductionQr, {
        manual: true,
        onSuccess: () => {
            refresh()
            setImportModalVisible(false)
        }
    })

    const {run: onModify} = useRequest(api.modifyProductQr, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const {run: onDelete} = useRequest(api.deleteProductQrs, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: 'SKU Cover',
            dataIndex: 'sku',
            width: '20%',
            search: true
        },
        {
            title: 'QR URL',
            dataIndex: 'url',
            width: '50%',
            editable: true,
        },
        {
            title: 'Operations',
            dataIndex: 'operations',
            width: '30%',
            render: (_, record: any) => (
                editingKey && editingKey === record.id ? (
                    <span>
                        <a onClick={() => saveEdit()}>Save</a>
                        <Divider type={"vertical"}/>
                        <Popconfirm title={'Are you sure?'} onConfirm={() => cancelEdit()}>
                            <a>Cancel</a>
                        </Popconfirm>
                    </span>
                ) : (
                    <span>
                        <EditFragment>
                            <Typography.Link disabled={editingKey && editingKey !== record.id}
                                             onClick={() => edit(record.id, record)}>Edit</Typography.Link>
                            <Divider type={"vertical"}/>
                        </EditFragment>
                        <DeletePopconfirm title={'Are you sure?'} onConfirm={() => onDelete([record.id])}>
                            <a>Delete</a>
                        </DeletePopconfirm>
                    </span>
                )
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <ImportButton type={'primary'} onClick={() => setImportModalVisible(true)}>Import</ImportButton>
                    <DeleteButton type={'primary'} onClick={() => {
                        if (selectedRowKeys) {
                            return onDelete(selectedRowKeys)
                        }
                    }}>Delete</DeleteButton>
                </Space>
            )}/>
            <UploadModal title={'Import SKU RP URL'}
                         template={'/template/skuQRURL.xlsx'}
                         confirmLoading={onImporting}
                         onUpload={onImport}
                         visible={importModalVisible}
                         onCancel={() => setImportModalVisible(false)}/>
        </PageHeaderLayout>
    )
}

export default ProductQr
